export default "__VITE_ASSET__0935c65a__"